'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadImageFromFile = exports.loadImageFromDataUrl = undefined;

var _promisedFileReader = require('../file/promisedFileReader');

var loadImageFromDataUrl = exports.loadImageFromDataUrl = function loadImageFromDataUrl(srcBase64) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = resolve;
        img.src = srcBase64;
    });
}; // Utils
var loadImageFromFile = exports.loadImageFromFile = function loadImageFromFile(file) {
    return (0, _promisedFileReader.readAsDataURL)(file).then(loadImageFromDataUrl);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/image/loadImage.js
// module id = 2139
// module chunks = 0